import { UPDATE_PROGRESS } from "../actions/types";

const initialState = null;

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PROGRESS:
      return payload;

    default:
      return state;
  }
}
